<template>
  <a-form :form="form">
    <a-form-item label="文章模块" :label-col="labelCol" :wrapper-col="{ span: 6 }">
      <a-select v-decorator="[
        'type',
        {
          rules: [{ required: true, message: '请选择模块' }],
          initialValue: initialValue.type
        }
      ]" 
        @change="handleTypeChange"
      >
        <a-select-option :value="typeMap.THE_LATEST_FROM_BIGO.value">
          {{ typeMap.THE_LATEST_FROM_BIGO.msg }}
        </a-select-option>
        <a-select-option :value="typeMap.BIGO_ON_THE_MEDIA.value">
          {{ typeMap.BIGO_ON_THE_MEDIA.msg }}
        </a-select-option>
        <a-select-option :value="typeMap.CREATOR_STORIES.value">
          {{ typeMap.CREATOR_STORIES.msg }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item v-show="isOnTheMedia" label="文章来源" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-input v-decorator="[
        'contentSource',
        {
          rules: [{ required: isOnTheMedia, message: '请填写文章来源' }],
          initialValue: initialValue.contentSource
        }  
      ]" />
    </a-form-item>

    <a-form-item label="文章标题" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-input v-decorator="[
        'title',
        {
          rules: [{ required: true, message: '请填写标题' }],
          initialValue: initialValue.title
        }  
      ]" />
    </a-form-item>

    <a-form-item label="是否首页推荐" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-radio-group v-decorator="[
        'isRecommend',
        {
          rules: [{ required: true, message: '请选择是否推荐' }],
          initialValue: initialValue.isRecommend
        }
      ]">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="显示优先级" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-input-number
        :min="0"
        v-decorator="[
          'priority',
          {
            rules: [{ required: true, message: '请填写优先级' }],
            initialValue: initialValue.priority
          }
        ]"
      />
    </a-form-item>

    <a-form-item
      label="添加日期"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-date-picker
        :allowClear="false"
        v-decorator="[
          'createdAt',
          {
            rules: [{ required: true, message: '请选择日期' }],
            initialValue: initialValue.createdAt
          }
        ]"
      />
    </a-form-item>

    <a-form-item v-show="isOnTheMedia" label="文章图标图" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-upload
        v-decorator="[
          'sourceCover',
          {
            initialValue: initialValue.sourceFile,
            valuePropName: 'fileList',
            getValueFromEvent: normFile,
            rules: [{ required: isOnTheMedia, message: '请上传封面图' }]
          },
        ]"
        name="file"
        action="https://bfs.bigo.sg/file/new?bucket=bigo-official"
        listType="picture"
        :data="uploadData"
        :beforeUpload="beforeUpload"
        :remove="removeSourceCover"
        @change="onUploadChange"
      >
        <a-button>
          <a-icon type="upload" /> Click to Upload
        </a-button>
      </a-upload>
    </a-form-item>

    <a-form-item label="文章封面图" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-upload
        v-decorator="[
          'cover',
          {
            initialValue: initialValue.file,
            valuePropName: 'fileList',
            getValueFromEvent: normFile,
            rules: [{ required: true, message: '请上传封面图' }]
          },
        ]"
        name="file"
        action="https://bfs.bigo.sg/file/new?bucket=bigo-official"
        listType="picture"
        :data="uploadData"
        :beforeUpload="beforeUpload"
        :remove="removeCover"
        @change="onUploadChange"
      >
        <a-button>
          <a-icon type="upload" /> Click to Upload
        </a-button>
      </a-upload>
    </a-form-item>

    <a-form-item v-show="isOnTheMedia" label="文章内容链接" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-input v-decorator="[
        'contentUrl',
        {
          rules: [{ required: isOnTheMedia, message: '请填写文章内容链接' }],
          initialValue: initialValue.contentUrl
        }  
      ]" />
    </a-form-item>

    <a-form-item v-show="!isOnTheMedia" label="文章内容" :label-col="labelCol" :wrapper-col="wrapperCol">
      <Editor
        :initial-value="initialValue.content"
        ref="tinymceEditor"
      ></Editor>
    </a-form-item>

    <a-form-item
      label=" "
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :colon="false"
    >
      <a-button @click="handleSave" type="primary" class="btn-save">保存</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import moment from 'moment';

import { getBucketToken, createArticle, updateArticle, getArticleDetail } from '@/apis/index';
import { articleTypeMap } from '@/constant/article';
import Editor from '@/components/Editor';

let hasSaved = false;

export default {
  components: {
    Editor,
  },
  props: {
    id: [Number, String],
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: this.$form.createForm(this),
      uploadData: {
        Authorization: '',
      },
      initialValue: {
        file: [],
        sourceFile: [],
        title: '',
        content: '',
        createdAt: moment(),
        type: '1',
        contentSource: '',
        sourceCover: '',
        contentUrl: ''
      },
      isOnTheMedia: false, // 是否为外部新闻
      // 文章模块的映射
      typeMap: articleTypeMap,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!hasSaved) {
      this.$confirm({
        title: '你将失去编辑中的内容，是否确认离开？',
        okText: '确认离开',
        cancelText: '取消',
        onOk: () => next(),
        onCancel: () => next(false),
      });
    } else {
      next();
    }
  },
  created() {
    if (this.id) {
      getArticleDetail(this.id)
        .then(({ code, data, msg }) => {
          if (code === 0) {
            this.initialValue = {
              ...data,
              createdAt: moment(data.createdAt),
              file: [],
              sourceFile: []
            };

            this.isOnTheMedia = data.type === this.typeMap.BIGO_ON_THE_MEDIA.value;

            if (data.cover) {
              this.initialValue.file = [{
                uid: data.cover,
                name: data.cover,
                url: data.cover,
                status: 'done',
              }];
            }
            if (data.sourceCover) {
              this.initialValue.sourceFile = [{
                uid: data.sourceCover,
                name: data.sourceCover,
                url: data.sourceCover,
                status: 'done',
              }];
            }
          } else {
            this.$message.error(msg);
          }
        });
    }
  },
  beforeDestroy() {
    hasSaved = false;
  },
  methods: {
    beforeUpload() {
      return getBucketToken()
        .then(({ data }) => {
          this.uploadData.Authorization = data;
        });
    },

    handleTypeChange(value) {
      this.isOnTheMedia = value === this.typeMap.BIGO_ON_THE_MEDIA.value;
    },

    onUploadChange(e) {
      const { file } = e;
      if (file && file.status === 'error') {
        let msg = '上传失败';

        if (file.response && file.response.err_msg && file.response.err_msg === 'File Size Invalid') {
          msg = '图片尺寸太大';
        }

        this.$message.error(msg);
      }
    },

    handleSave() {
      this.form.validateFields((err, fieldValues) => {
        if (!err) {
          const params = {
            ...fieldValues,
            content: this.$refs.tinymceEditor.getContent(),
            createdAt: fieldValues.createdAt.format('YYYY-MM-DD HH:mm:ss'),
          };

          if (params.cover[0] && params.cover[0].url) {
            params.cover = params.cover[0].url.replace(/^http:/, 'https:');
          } else {
            params.cover = '';
          }

          if (params.sourceCover[0] && params.sourceCover[0].url) {
            params.sourceCover = params.sourceCover[0].url.replace(/^http:/, 'https:');
          } else {
            params.sourceCover = '';
          }

          const apiMethod = this.id ? updateArticle : createArticle;
          apiMethod(params, this.id)
            .then(({ code, msg }) => {
              if (code === 0) {
                const back = this.$router.replace.bind(this.$router, { name: 'articles' });

                hasSaved = true;
                this.$message.success('保存成功', 1, back);
              } else {
                this.$message.error(msg);
              }
            })
            .catch((error) => {
              if (error.response.data) {
                if (error.response.data.code === 10002) {
                  this.$message.error('参数错误');
                }
              }
            });
        }
      });
    },

    normFile(e) {
      const { file } = e;
      if (file && file.status === 'done' && file.response && file.response.url) {
        file.url = file.response.url;
      }
      return [file];
    },

    removeCover() {
      this.form.setFieldsValue({ cover: [] });
    },

    removeSourceCover() {
      this.form.setFieldsValue({ sourceCover: [] });
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-save {
  width: 100px;
}

</style>
